import { DataService } from "@/services/data";
import { MetadataService } from "@/services/metadata";
import { MetabaseDashboardDetailType } from "@/types/tools/metabase_dashboard";
import { Outlet, RouteObject } from "react-router-dom";

const MetabaseRoute: RouteObject = {
    path: "rapports",
    element: <Outlet />,
    children: [
        {
            index: true,
            async lazy() {
                const { MetabaseDashboardList } = await import("@/pages/tools/metabase/list");
                return { Component: MetabaseDashboardList };
            },
            loader: async () => {
                const metadata = await MetadataService.get("/crm/objects/metabase-dashboards/");
                return { metadata };
            }
        },
        {
            path: ":id",
            async lazy() {
                const { MetabaseDashboardView } = await import("@/pages/tools/metabase/view");
                return { Component: MetabaseDashboardView };
            },
            loader: async ({ params }) => {
                const dashboard = (await DataService.client.url(`/crm/objects/metabase-dashboards/${params.id}/`).get().json()) as MetabaseDashboardDetailType;

                let embed_url: string | null = null;
                let embed_error: string | null = null;
                try {
                    const embed = (await DataService.client.url(`/crm/objects/metabase-dashboards/${params.id}/embed_url/`).get().json()) as { embed_url: string };
                    embed_url = embed.embed_url;
                } catch (e: any) {
                    embed_error = e?.message || "Failed to generate embed URL";
                }

                return { dashboard, embed_url, embed_error };
            }
        }
    ]
};

export default MetabaseRoute;
